<template>
  <article class="job-item cmn-card job-card-split job-card-skeleton">
    <div class="job-inner">
      <div class="position">
        <!-- Top: Avatar & Company Name / Time -->
        <div class="job-list-meta">
          <div class="job-avatar avatar-logo skeleton-box skeleton-avatar-box"></div>
          <div class="company-name-container">
            <div class="skeleton-box skeleton-company-name"></div>
            <div class="skeleton-box skeleton-job-time"></div>
          </div>
        </div>

        <!-- Middle: Title & Short description -->
        <div class="job-info">
          <div class="skeleton-box skeleton-job-title"></div>
          <div class="skeleton-box skeleton-job-desc"></div>
        </div>

        <!-- Meta Row: Job Type Badge & Salary -->
        <div class="job-meta-row">
          <div class="skeleton-box skeleton-badge"></div>
          <div class="skeleton-box skeleton-salary"></div>
        </div>
      </div>
    </div>

    <!-- Bottom: Location & Action Button -->
    <div class="job-action">
      <div class="skeleton-box skeleton-location"></div>
      <div class="skeleton-box skeleton-btn"></div>
    </div>
  </article>
</template>

<script>
export default {
  name: "JobCardSkeleton"
};
</script>
